var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t(_vm.heading)))]),_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.formatter ? _vm.formatter(_vm.value) : _vm.value ?? "-")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }